/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import emailCheckStyle from "./emailCheckStyle";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import ValidatorTextField, { ValidatorTextFieldProps } from "@/src/components/FormFields/ValidatorTextField";
import { useForm } from "@/src/provider/Form/FormProvider";
import { useAuthDialog } from "@/src/provider/AuthDialog/AuthDialogProvider";
import { NavigateProps } from "react-router";

type EmailCheckProps = {
  emailErrorText: string;
  setEmailErrorText: (emailErrorText: string) => void;
  redirectProps?: NavigateProps["to"] | null;
} & ValidatorTextFieldProps;

export default function EmailCheck({ label, name, emailErrorText, setEmailErrorText, redirectProps = null, ...rest }: EmailCheckProps) {
  const { setView } = useAuthDialog();
  const { handleChange, errors, values } = useForm();

  const openLogin = async () => {
    setView({
      type: "login",
      showPostfix: false,
      redirectTo: redirectProps,
      initialEmail: values.email ?? "",
    });
  };

  const isError = !!errors[name] || emailErrorText !== "";
  const errorText = emailErrorText || (
    <Grid
      component={"span"}
      container
      sx={{
        alignItems: "center",
      }}
    >
      <Grid component={"span"} sx={emailCheckStyle.emailHelperText}>
        Bereits ein Konto?
      </Grid>
      <Button component={"span"} variant={"text"} color={"primary"} onClick={openLogin}>
        Jetzt anmelden
      </Button>
    </Grid>
  );
  return (
    <>
      <ValidatorTextField
        label={label}
        name={name}
        error={isError}
        helperText={isError && errorText ? errorText : ""}
        onChange={(e) => {
          setEmailErrorText("");
          handleChange(e);
        }}
        {...rest}
      />
    </>
  );
}
